module.exports = __webpack_public_path__ + "static/media/RFID_FILE_template.10ed79a1.csv";